const _utils = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  }
}

class ProductGalleryWrap extends HTMLElement {
  constructor() {
    super();
    setTimeout(this.SetGalleryHeight.bind(this), 0);
  }
  SetGalleryHeight() {
    let header_height = document.querySelector('.shopify-section--header').clientHeight + document.querySelector('.shopify-section--announcement-bar').clientHeight;
    this.style.setProperty('--header-height', header_height + 'px');

    let $gallery = this.querySelector('scroll-carousel');
    let $navigation = this.querySelector('product-gallery-navigation');

    $navigation.style.maxHeight = $gallery.clientHeight + 'px';
  }
}
customElements.define('product-gallery-wrap', ProductGalleryWrap);

class ProductQuantitySelector extends HTMLElement {
  // TODO - this impacts CLS slightly (needs improvement)
  constructor() {
    super();
    this.MoveQuantityToForm();
  }
  MoveQuantityToForm() {
    let $form = document.querySelector('[data-block-id="buy_buttons"] product-form');
    if (!$form) return;

    $form.style.opacity = 0;
    $form.insertAdjacentElement('afterbegin', this);
    $form.style.opacity = 1;
  }
}
customElements.define('product-quantity-selector', ProductQuantitySelector);

class ImageWithTextBullets extends HTMLElement {
  static observedAttributes = ["active_index"];

  constructor() {
    super();
    this.Init();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // console.log({name, oldValue, newValue});
    if (name == 'active_index') {
      this.querySelectorAll('li').forEach(($li) => {
        $li.classList.toggle('item-active', $li.getAttribute('data-index') == newValue);
      });  
    }
  }  
  Init() {
    this.querySelectorAll('.titles li').forEach($li => {
      $li.addEventListener('click', () => {
        this.setAttribute('active_index', $li.getAttribute('data-index'));
      });
    });
  }
}
customElements.define('image-with-text-bullets', ImageWithTextBullets);

class MultiColumnSwiper extends HTMLElement {
  constructor() {
    super();
    this.Init();
  }

  Init() {
    let swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: this.dataset.slides_per_row_mobile,
      spaceBetween: 0,
      navigation: {
        prevEl: this.querySelector('.prev-next-button--prev'),
        nextEl: this.querySelector('.prev-next-button--next'),
      },
      on: {
        init: this.Update.bind(this),
        resize: this.Update.bind(this),
      },
      breakpoints: {
        768: {
          slidesPerView: parseFloat(this.dataset.slides_per_row_mobile) * 2,
        },
        1024: {
          slidesPerView: parseFloat(this.dataset.slides_per_row_mobile) * 1.5,
          slidesPerGroup: 3,
        },
        1280: {
          slidesPerView: parseFloat(this.dataset.slides_per_row),
          slidesPerGroup: 3
        }
      }
    });
  }

  Update() {
    let slides_per_row_mobile = parseFloat(this.dataset.slides_per_row_mobile);
    let slides_per_row = parseFloat(this.dataset.slides_per_row);
    let is_mobile = window.matchMedia('(max-width: 767px)').matches;
    let is_tablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
    let is_desktop = window.matchMedia('(min-width: 1280px)').matches;

    let slides_count = this.querySelectorAll('.swiper-slide').length;

    if (is_mobile) {
      this.classList.toggle('justify-center', slides_count <= slides_per_row_mobile);
    }
    if (is_tablet) {
      this.classList.toggle('justify-center', slides_count <= slides_per_row_mobile * 2);
    }
    if (is_desktop) {
      this.classList.toggle('justify-center', slides_count <= slides_per_row);
    }
  }
}
customElements.define('multi-column-swiper', MultiColumnSwiper);

class HeaderSidebarSearch extends HTMLElement {
  constructor() {
    super();
    this.Init();
  }

  Init() {
    this.querySelector('a').addEventListener('click', (e) => {
      e.preventDefault();
      let $search = document.querySelector(`[aria-controls="${this.dataset.controls}"]`);
      $search.click();

      let $search_input = document.querySelector('.header-search__input');
      $search_input.focus();
    });
  }
}
customElements.define('header-sidebar-search', HeaderSidebarSearch);

class SplitSlide extends HTMLElement {
  constructor() {
    super();
    this.RenderParallax();

    let mq_mobile = window.matchMedia('(max-width: 767px)');
    mq_mobile.addEventListener('change', this.RenderParallax.bind(this));
  }

  RenderParallax() {
    if (this.dataset.enable_parallax !== 'true') return;
    let mq_mobile = window.matchMedia('(max-width: 767px)');
    let is_mobile = mq_mobile.matches;
    if (!is_mobile) return;

    let $first = this.querySelector('.content-over-media:first-child');
    let $second = this.querySelector('.content-over-media:last-child');

    let $section = $first.closest('.shopify-section');
    let $next_section = $section.nextElementSibling;
    if (!$next_section) return;

    $second.classList.add('is-absolute');

    // when next section is intersecting, add fixed class
    _utils.ObserveIntersection($next_section, {}, (entries) => {
      let entry = entries[0];
      // console.log(entry);
      $second.classList.toggle('is-fixed', entry.isIntersecting);
    });

    _utils.ObserveIntersection($first, {}, (entries) => {
      let entry = entries[0];
      // console.log(entry);
      // when top slide has moved past, remove fixed classes
      if ($second.classList.contains('is-fixed') && !entry.isIntersecting) {
        $second.classList.remove('is-fixed');
        $second.classList.remove('is-absolute');
      }

      // when scrolled back to top, add absolute class
      let hasMovedTop = entry.boundingClientRect.top > entry.boundingClientRect.height;
      if (hasMovedTop) {
        $second.classList.add('is-absolute');
      }
    });
  }
}
customElements.define('split-slide', SplitSlide);
